/**
 * Author: Stefan Haack (https://shaack.com)
 */
import {LocalPlayerWithPreMoves} from "../../../lib/chess-console/players/LocalPlayerWithPreMoves.js"
import {consoleMessageTopics} from "../../../lib/chess-console/ChessConsole.js"
import {INPUT_EVENT_TYPE} from "../../../lib/cm-chessboard/Chessboard.js"
import {CONSOLE_MARKER_TYPE} from "../components/Board.js"
import {debugLog} from "../../lib.js"

export class GambitLocalPlayer extends LocalPlayerWithPreMoves {

    constructor(chessConsole, name, props) {
        super(chessConsole, name, props)
        chessConsole.messageBroker.subscribe(consoleMessageTopics.legalMove, (data) => {
            if (data.playerMoved === this) {
                debugLog(chessConsole.props.debug, "player moved", data)
                chessConsole.app.webSocketConnection.sendMove(this.chessConsole.app.props.accessToken,
                    data.move.from + data.move.to + (data.move.promotion ? data.move.promotion : ""))
            }
        })
    }

    moveInputCallback(event, ignored, boardFen, moveResponse) {
        // if player can make move, make, if not store as premove
        event.chessboard.removeMarkers(CONSOLE_MARKER_TYPE.legalMoves)
        event.chessboard.removeMarkers(CONSOLE_MARKER_TYPE.legalMovesCapture)
        if(event.type === INPUT_EVENT_TYPE.moveInputStarted) {
            const moves = this.chessConsole.state.chess.moves({square: event.square, verbose: true});
            for (const move of moves) { // draw dots on possible squares
                if(event.chessboard.getPiece(move.to)) {
                    event.chessboard.addMarker(CONSOLE_MARKER_TYPE.legalMovesCapture, move.to)
                } else {
                    event.chessboard.addMarker(CONSOLE_MARKER_TYPE.legalMoves, move.to)
                }
            }
        }

        const gameFen = this.chessConsole.state.chess.fen()
        if (this.chessConsole.playerToMove() === this) {
            if (event.type === INPUT_EVENT_TYPE.moveDone) {
                return this.validateMoveAndPromote(gameFen, event.squareFrom, event.squareTo, (moveResult) => {
                    let result
                    if (moveResult) { // valid
                        result = moveResponse(moveResult)
                    } else { // not valid
                        result = moveResponse({from: event.squareFrom, to: event.squareTo})
                        this.premoves = []
                        this.updatePremoveMarkers()
                    }
                    if (result) {
                        // this.chessConsole.board.chessboard.disableMoveInput()
                    }
                })
            } else if (event.type === INPUT_EVENT_TYPE.moveStart) {
                if (this.chessConsole.state.plyViewed !== this.chessConsole.state.chess.plyCount()) {
                    this.chessConsole.state.plyViewed = this.chessConsole.state.chess.plyCount()
                    return false
                } else {
                    return true
                }
            }
        } else {
            if (event.type === INPUT_EVENT_TYPE.moveDone) {
                this.premoves.push(event)
                // set markers for the premoves
                this.updatePremoveMarkers()
            }
            return true
        }
    }

}
